import React from 'react'
import ReactDOM from 'react-dom'
import { SimulationApp } from './components/SimulationApp'
import { SimulationChainApp } from './components/SimulationChainApp'

export const startSimulation = (containerId, config) => {
  const container = document.getElementById(containerId)
  if (!container) {
    console.error(`Simulation: container element "#${containerId}" not found`)
    return
  }
  ReactDOM.render(<SimulationApp config={config} />, container)
}

export const startSimulationChain = (containerId, config) => {
  const container = document.getElementById(containerId)
  if (!container) {
    console.error(`SimulationChain: container element "#${containerId}" not found`)
    return
  }
  ReactDOM.render(<SimulationChainApp config={config} />, container)
}
